import React, { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { PlayCircle } from 'lucide-react';

export const ActionNode = memo(({ data, isConnectable }: NodeProps) => {
  return (
    <div className="bg-white border-2 border-indigo-200 rounded-lg shadow-sm min-w-[200px] hover:border-indigo-500 transition-colors">
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-indigo-500 border-2 border-white"
      />
      <div className="bg-indigo-50 border-b border-indigo-100 p-2 rounded-t-md flex items-center gap-2">
        <div className="bg-indigo-600 text-white p-1 rounded">
          <PlayCircle className="h-3 w-3" />
        </div>
        <div className="flex flex-col">
          <div className="text-sm font-semibold text-gray-900">Action</div>
          {data?.label && (
            <div className="text-xs text-gray-500 font-medium">
              {data.label as string}
            </div>
          )}
        </div>
      </div>
      <div className="p-3">
        <div className="text-xs text-gray-500">
          Type: {(data?.config as any)?.actionType || 'Not configured'}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-indigo-500 border-2 border-white"
      />
    </div>
  );
});

ActionNode.displayName = 'ActionNode';
